// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3xbK-","top":"styles_top__3z7uD"};